export const orderFieldNames = {
  ADDRESS: 'address',
  CITY: 'city',
  DELIVERY: 'delivery',
  FAMILY: 'family',
  FAMILY_KINSHIP: 'kinship',
  FAMILY_CONTACT: 'contact',
  FAMILY_NAME: 'name',
  FAMILY_LASTNAME: 'last_name',
  FAMILY_PATRONYMIC: 'patronymic',

  OTHER: 'another',
  OTHER_KINSHIP: 'kinship',
  OTHER_NAME: 'name',
  OTHER_LASTNAME: 'last_name',
  OTHER_PATRONYMIC: 'patronymic',
  OTHER_PHONE: 'phone',
  OTHER_EMAIL: 'email',
  OTHER_FAMILY_COUNT: 'family_count',
}

export const deliveryTypes = {
  COURIER: '1',
  PICKUP: '2',
}

export const forWhomTypes = {
  YOURSELF: 'YOURSELF',
  OTHERS: 'OTHERS'
}